// extracted by mini-css-extract-plugin
export default {"productFormContainer":"Products_productFormContainer__FnqxM"};